import styled from '@emotion/styled'

import { Checkbox as CheckboxComponent } from '../../Form'
import { rowStyles } from '../styles'

interface TableRowStylesProps {
  columns: string
  rowSpacing?: number
}

export const TableRowWrapper = styled.tr<TableRowStylesProps>`
  ${rowStyles};
  grid-template-columns: ${({ columns }) => columns};
  grid-column-gap: ${({ rowSpacing }) => rowSpacing || 30}px;
`

export const CheckboxWrapper = styled.td`
  display: flex;
  align-items: center;
  height: 100%;
  position: absolute;
  left: 6px;
  cursor: default;
`
export const Checkbox = styled(CheckboxComponent)`
  margin: 0;

  label {
    margin: 0;
  }
`
